<template>
  <div>
    <div class="fixed">
      <transition name="fade">
        <div class="alert alert-danger" role="alert" v-if="registrationFail">
          <span style="font-style: italic; font-weight: bold"> Email already exists! </span>
        </div>
      </transition>
      <transition name="fade">
        <div class="alert alert-success" role="alert" v-if="registrationSuccess">
          <span style="font-style: italic; font-weight: bold"> Login Success! </span> Redirecting to Login ...
        </div>
      </transition>
    </div>
    <div class="d-flex align-items-center min-vh-100">
      <CContainer fluid>
        <CRow class="justify-content-center">
          <CCol md="6">
            <CCard class="mx-4 mb-0">
              <CCardBody class="p-4">
                <CForm @submit.prevent="register" method="POST">
                  <h1>Register</h1>
                  <p class="text-muted">Create your account</p>
                  <CInput
                      placeholder="Username"
                      prependHtml="<i class='cui-user'></i>"
                      autocomplete="username"
                      v-model="name"
                      type="text"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                      placeholder="Email"
                      prepend="@"
                      autocomplete="email"
                      v-model="email"
                      type="email"
                  />
                  <div>
                    <CInput
                        placeholder="Password"
                        :type="showPassword? 'text' : 'password'"
                        appendHtml
                        v-model="password"
                        prependHtml
                        @focus="magic_flag = true"
                        @blur="magic_flag = false">
                      <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                      <template #append-content>
                        <font-awesome-icon
                            @click="showPassword = !showPassword"
                            :icon="showPassword? 'eye' : 'eye-slash'"
                        />
                      </template>
                    </CInput>
                    <password v-model="password" v-if="magic_flag" :strength-meter-only="true" :toggle="true"/>
                  </div>
                  <div>
                    <CInput
                        placeholder="Repeat password"
                        :type="showPasswordRepeat? 'text' : 'password'"
                        appendHtml
                        v-model="password_confirmation"
                        prependHtml
                        @focus="magic_flag_repeat = true"
                        @blur="magic_flag_repeat = false">
                      <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                      <template #append-content>
                        <font-awesome-icon
                            @click="showPasswordRepeat = !showPasswordRepeat"
                            :icon="showPasswordRepeat? 'eye' : 'eye-slash'"
                        />
                      </template>
                    </CInput>
                    <password v-model="password_confirmation" v-if="magic_flag_repeat" :strength-meter-only="true" :toggle="true"/>
                  </div>
                  <CButton type="submit" color="success" block>Create Account</CButton>
                </CForm>
              </CCardBody>
              <!-- <CCardFooter class="p-4">
                <CRow>
                  <CCol col="6">
                    <CButton block color="facebook">
                      Facebook
                    </CButton>
                  </CCol>
                  <CCol col="6">
                    <CButton block color="twitter">
                      Twitter
                    </CButton>
                  </CCol>
                </CRow>
              </CCardFooter> -->
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Password from 'vue-password-strength-meter'
  export default {
    components: { Password },
    data() {
      return {
        name: '',
        email: '',
        // password: '',
        password: null,
        // password_confirmation: '',
        password_confirmation: null,
        registrationSuccess: false,
        registrationFail: false,
        magic_flag: false,
        showPassword: false,
        magic_flag_repeat: false,
        showPasswordRepeat: false
      }
    },
    mounted() {
      document.title = 'Starter Grower | Register'
    },
    methods: {
      register() {
        var self = this;
        axios.post(  this.$apiAdress + '/api/register', {
          name: self.name,
          email: self.email,
          password: self.password,
          password_confirmation: self.password_confirmation
        }).then(function (response) {
          self.registrationSuccess = true
          self.registrationFail = false
          self.reset()
          console.log('register', response);
          self.$router.push({ path: '/login' });
        })
        .catch(function (error) {
          console.log(error);
          self.registrationFail = true
          self.reset()

          setTimeout(function () {
            self.registrationFail = !self.registrationFail
          }.bind(this), 5000);
        });
      },
      reset() {
        const self = this;
        self.name = '';
        self.email = '';
        self.password = '';
        self.password_confirmation = '';
      },
      showFeedback ({suggestions, warning}) {
        console.log('🙏', suggestions)
        console.log('⚠', warning)
      },
      showScore (score) {
        console.log('💯', score)
      }
    }
  }

</script>

<style scoped>
  .fixed {
    position: fixed;
    width: 20%;
    bottom: 10px;
    z-index: 1;
    right: 2%;
  }
</style>
